// Helper function to format number with commas and $ sign (no decimals for revenue)
export const formatNumberWithCommas = value => {
  if (!value) return "";
  // Remove all non-digit characters
  const numericValue = value.toString().replace(/[^\d]/g, "");
  if (!numericValue) return "";
  // Add commas to integer part and $ sign
  return "$" + numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Helper function to format percentage (max 4 total digits with up to 2 decimal places, with % sign)
export const formatPercentage = value => {
  if (!value) return "";
  // Remove all non-digit characters except decimal point
  const numericValue = value.toString().replace(/[^\d.]/g, "");

  // Split into integer and decimal parts
  const parts = numericValue.split(".");

  // If there's a decimal part (user typed it)
  if (parts.length > 1) {
    // Limit integer part to 2 digits
    parts[0] = parts[0].substring(0, 2);
    parts[1] = parts[1].substring(0, 2);
    return parts.join(".") + "%";
  }

  // No decimal typed - auto-add decimal after 2 digits
  const digits = parts[0];
  if (digits.length > 2) {
    // Split: first 2 digits before decimal, rest after (max 2)
    const beforeDecimal = digits.substring(0, 2);
    const afterDecimal = digits.substring(2, 4);
    return beforeDecimal + "." + afterDecimal + "%";
  }

  // 2 or fewer digits - no decimal
  return digits + "%";
};

// Helper function to format phone number as (000) 000-0000
export const formatPhoneNumber = value => {
  if (!value) return "";
  // Remove all non-digit characters
  const digits = value.toString().replace(/\D/g, "");

  // Limit to 10 digits
  const limitedDigits = digits.substring(0, 10);

  // Format based on length
  if (limitedDigits.length <= 3) {
    return limitedDigits;
  } else if (limitedDigits.length <= 6) {
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3)}`;
  } else {
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3, 6)}-${limitedDigits.slice(6)}`;
  }
};

// Helper function to format email address (lowercase and trim whitespace)
export const formatEmail = value => {
  if (!value) return "";
  // Trim whitespace and convert to lowercase
  return value.toString().trim().toLowerCase();
};

// Helper function to parse comma-formatted number and remove $ and % signs
export const parseFormattedNumber = value => {
  if (!value) return "";
  return value.toString().replace(/[,$%]/g, "");
};
